/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 监管动态搜索
 */

import commonStyles  from '../../common/common.scss';
import React, { PureComponent } from 'react';
import { Form, DatePicker, Select } from 'antd';
import cns from 'classnames';
import { LettersTypeText } from '../../../../../constants/info';
import { dateFormat } from '../../../../../utils/formatter';
import { getOptionsByKV } from '../../../../../utils/util';
import CompanyAutoComplete from '../../../../common/companyAutoComplete/CompanyAutoComplete';
const FormItem = Form.Item;
const Option  = Select.Option;
const { RangePicker } = DatePicker;

class SearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            options: {
                letterType: getOptionsByKV(LettersTypeText)
            }
        };
    }

    componentDidMount() {
        this.onSubmit();
    }

    getCompanyInfo = (selectedCompany) => {
        this.selectedCompany = selectedCompany;
    };

    resetCompanyInfo = (v) => {
        if (!this.selectedCompany || v !== this.selectedCompany.name) {
            this.selectedCompany = null;
        }
    };

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields, setFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                const { company, date, ...others } = values;
                if (company && !this.selectedCompany) { // 没有选择公司
                    setFields({
                        company: {
                            value: company,
                            errors: [new Error('请选择公司')]
                        }
                    });
                    return;
                }
                onSearch && onSearch({
                    companyCode: this.selectedCompany ? this.selectedCompany.code : undefined,
                    startDate: date[0] && dateFormat(date[0]),
                    endDate: date[1] && dateFormat(date[1]),
                    ...others
                });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { options } = this.state;
        const { letterType } = options;

        return (
            <div className={cns('search-bar', commonStyles.searchBar)}>
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <FormItem>
                        {getFieldDecorator('company', {
                            rules: [{
                                required: false, message: ''
                            }],
                            initialValue: ''
                        })(
                            <CompanyAutoComplete placeholder="请输入公司名称或代码" onChange={this.resetCompanyInfo} getCompanyInfo={this.getCompanyInfo}/>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('date', {
                            initialValue: []
                        })(
                            <RangePicker />
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('publishType', {
                            initialValue: ''
                        })(
                            <Select size="default" className={commonStyles.large}>
                                <Option value="">全部</Option>
                                { letterType.map(d => <Option key={d.key} value={d.key}>{d.value}</Option>) }
                            </Select>
                        )}
                    </FormItem>
                    <button type="submit" className="btn btn-blue">搜索</button>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/state/file/SearchForm.jsx